module.exports = __webpack_public_path__ + "img/7357.efb78fce.jpg";